import Provider from './src/lib/context'
import { PageProvider } from './src/lib/context'

import rootStore from './src/stores/store'
const React = require('react')


const isCPRARegion = (location) => {
	return location.countryCode === 'US' && location.regionCode === 'CA';
  }

const domainScript = () => {
	let id = '41e15231-4a82-4457-b3aa-67f11aea3ee2';
	if (process.env.NODE_ENV === 'development' || process.env.GATSBY_APP_CONTEXT !== 'production') {
		return `${id}-test`;
	};
	return id;
}

export const onPreRouteUpdate = (props) => {
	rootStore.transitionStore.startTransition(props.location, props.prevLocation);
}
// Logs when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
	// rootStore.uiStore.scrollTo(0)
	setTimeout(rootStore.transitionStore.endTransition, 1000)
	setTimeout(() => {
		window.scrollTo({top: 0, behavior: "instant"});
	},  400)



	rootStore.uiStore.clearRouteVaribles()

	if (location && (location.pathname === "/" || location.pathname === "/bloomseason/")) {

		rootStore.uiStore.initMapAnimation()
	}

	setTimeout(() => {
		rootStore.uiStore.getPageHeight()
	}, 1000)
}

// export const wrapPageElement = PageProvider

export const wrapPageElement = PageProvider
export const wrapRootElement = Provider

export const shouldUpdateScroll = () => {
	// transition duration from `layout.js` * 1000 to get time in ms
	// const TRANSITION_DELAY = 0.3 * 1000 * 2

	// // if it's a "normal" route
	// if (location.action === 'PUSH') {
	// 	window.setTimeout(() => window.scrollTo(0, 0), TRANSITION_DELAY)
	// }

	// // if we used the browser's forwards or back button
	// else {
	// 	// breaking change in shouldUpdateScroll browser API hook:
	// 	// https://github.com/gatsbyjs/gatsby/issues/23842
	// 	// looks like they fixed it in Gatsby v. 2.28.1
	// 	// https://github.com/gatsbyjs/gatsby/pull/27384

	// 	const savedPosition = getSavedScrollPosition(location) || [0, 0]

	// 	window.setTimeout(() => window.scrollTo(...savedPosition), TRANSITION_DELAY)
	// }

	return false
}

export const onClientEntry = () => {
	fetch('/bloomseason/geolocation')
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			return {
				countryCode: data?.geo?.country?.code,
				regionCode: data?.geo?.subdivision?.code,
			};
		})
		.then((geo) => {
			if (isCPRARegion(geo)) {
				const gdprUtilsScript = document.createElement('script');
				gdprUtilsScript.type = 'text/javascript';
				gdprUtilsScript.src = 'https://uxfabric.intuitcdn.net/gdpr-util/2.8.0/gdprUtilBundle.js';
				gdprUtilsScript.defer = true;
				document.head.appendChild(gdprUtilsScript);
			}

			fetch('/search/asset-path/?q=cookie-preferences-manager')
				.then((response) => {
					return response.json();
				})
				.then((path) => {
					const cookiePreferencesManagerScript = document.createElement(
						'script',
					);
					cookiePreferencesManagerScript.src = path;
					cookiePreferencesManagerScript.type = 'module';
					cookiePreferencesManagerScript.dataset.domainScript = domainScript();
					cookiePreferencesManagerScript.dataset.hostName = 'mailchimp.com';
					cookiePreferencesManagerScript.dataset.countryCode = geo.countryCode;
					cookiePreferencesManagerScript.dataset.regionCode = geo.regionCode;
					cookiePreferencesManagerScript.dataset.id =
						'cookie-preferences-manager';
					cookiePreferencesManagerScript.defer = true;
					cookiePreferencesManagerScript.async = false;
					document.head.appendChild(cookiePreferencesManagerScript);
				})
		.catch((error) => {
			console.error(error);
		});
	});
};
